// 关于滚轮事件的函数

/**
 * @method 用来滚动条返回顶部
 * @param s 是用来返回控制速度的,不传默认为30
 */
export const backTop = (s) => {
  // 获取高度
  let top = getScrollTop()
  let foo = false
  // 防止二次点击
  if (foo) {
    return
  } else {
    foo = true
  }
  // 速度
  let speed = s || 30
  let timer = setInterval(() => {
    top = top - speed
    if (top <= 0) {
      window.scrollTo(0, 0)
      clearInterval(timer)
    } else {
      window.scrollTo(0, top)
    }
  }, 10)
  return timer
}

/**
 * @method 滚动条距离顶部距离
 */
export const getScrollTop = () => {
  let scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop
  return scrollTop
}

/**
 * @method 可视窗口高度
 */
export const getClientHeight = () => {
  let clientHeight = 0
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight
  } else {
    clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight
  }
  return clientHeight
}

// 滚动条在Y轴上的滚动距离
export const getScrollTops = () => {
  let scrollTop = 0
  let bodyScrollTop = 0
  let documentScrollTop = 0
  if (document.body) {
    bodyScrollTop = document.body.scrollTop
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
  return scrollTop
}

// 文档的总高度
export function getScrollHeight () {
  let scrollHeight = 0
  let bodyScrollHeight = 0
  let documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
  return scrollHeight
}

// 浏览器视口的高度
export function getWindowHeight () {
  var windowHeight = 0
  if (document.compatMode === 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight
  } else {
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

// 浏览器视口的宽度
export function getWindowWidth () {
  var winWidth = 0
  if (window.innerWidth) {
    winWidth = window.innerWidth
  } else if ((document.body) && (document.body.clientWidth)) {
    winWidth = document.body.clientWidth
  }
  return winWidth
}



// WEBPACK FOOTER //
// ./src/assets/utils/scroll.js